import { Component } from "react"
import dispatchEvent from "../../helpers/dispatch-event"
import { root } from "../../services/Globals"

const noop = () => {}

export default class PostPlayModes extends Component {
  constructor(props) {
    super(props)
    this.initialState = {
      mode: `idle`,
      payload: undefined,
    }
    this.state = this.initialState
  }

  render = () => {
    const {
      state: { mode, payload },
      create,
    } = this

    return this.props.children({
      mode,
      payload,
      create,
    })
  }

  create = options => {
    const {
      data,
      arrangementId,
      versionId,
      onSuccess = noop,
      onError = noop,
      onLoading = noop,
    } = options || this.props

    this.setState(
      previousState => ({
        ...previousState,
        mode: `loading`,
      }),
      onLoading
    )

    return root.wav
      .api({
        method: `post`,
        url: `/arrangements/${ arrangementId }/versions/${ versionId }/playmodes`,
        data,
      })
      .then(response => {
        onSuccess(response.data)
        dispatchEvent(`update:${ arrangementId }:playModes`)
        dispatchEvent(`update:${ versionId }:playModes`)
        return response
      })
      .catch(error => {
        this.setState(
          previousState => ({
            ...previousState,
            mode: `error`,
            payload: error,
          }),
          () => onError(error)
        )
      })
  }
}
